import axios from "axios";
import { toast } from "react-toastify";

export type FormData = {
  firstName: string;
  lastName: string;
  subject: string;
  phone: string;
  email: string;
  orderReference?: string;
  message: string;
};

export const API_URL =
  process.env.REACT_APP_API_URL || "https://sp-hygiene.com/api";

export const postForm = async (formData: FormData) => {
  try {
    const response = await axios.post(`${API_URL}/contact`, formData);
    return response;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      console.error("Erreur Axios:", error.response?.data || error.message);
    }
    toast.error("Erreur lors de l'envoi du formulaire", {
      className: "toast-error",
    });
  }
};
